/**
 * Pre-paint offset for the thread route only. Kept separate from the shared
 * `--sidebar-width` (which other sidebars and the download manager own), and
 * read by the thread chrome only as a fallback until the sidebar syncs.
 * Dependency-free so layout shells can import it without pulling in the
 * sidebar preference modules.
 */
export const THREAD_SIDEBAR_OFFSET_BOOT_VAR = '--thread-sidebar-offset-boot';
